import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
type HighlightedSuggestionProps = {
  children: string;
};
type TemplatePart = {
  type: 'plain' | 'highlighted';
  span: string;
};
const HIGHLIGHT_REGEX = /{([^}]*)}|\(([^)]*)\)/g;
const parseTemplateToReactNodes = (template: string): TemplatePart[] => {
  const parts: TemplatePart[] = [];
  let cursor = 0;
  for (const match of template.matchAll(HIGHLIGHT_REGEX)) {
    const matchIndex = match.index;
    const fullMatch = match[0];
    const highlightedText = match[1] ?? match[2]; // {} or () content

    if (cursor < matchIndex) {
      const plainText = template.slice(cursor, matchIndex);
      if (plainText) parts.push({
        span: plainText,
        type: 'plain'
      });
    }
    if (highlightedText) {
      parts.push({
        span: highlightedText,
        type: 'highlighted'
      });
    }
    cursor = matchIndex + fullMatch.length;
  }
  if (cursor < template.length) {
    const remainingText = template.slice(cursor);
    if (remainingText) parts.push({
      span: remainingText,
      type: 'plain'
    });
  }
  return parts;
};
export const HighlightedSuggestion = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /[\[\]]/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = children.replace(t2, "");
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const template = t1;
  let t2;
  if ($[3] !== template) {
    t2 = parseTemplateToReactNodes(template);
    $[3] = template;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const parts = t2;
  let t3;
  if ($[5] !== parts) {
    t3 = parts.map(_temp);
    $[5] = parts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(part, index) {
  const content = part.span;
  return part.type === "highlighted" ? <strong key={content + index}>{content}</strong> : content;
}